import moment from "moment";

export const weeksInYear = (year: number) =>
  moment()
    .year(+year)
    .weeksInYear();
